import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { Observable } from 'rxjs/Observable';
import { ApplicationInfoModel } from '../../models/application.model';

@Injectable()
export class InfopageService {

  constructor (
    private http: HttpClientService
  ) { }

  public getVersion(ms_base_url: string): Observable<ApplicationInfoModel> {
    return this.http.get(ms_base_url + '/version');
  }

}



// WEBPACK FOOTER //
// ./src/app/services/infopage/infopage.service.ts